export default function TopProgress({ active }) {
  return (
    <div
      className={[
        "fixed top-0 left-0 right-0 h-[3px] z-[99999] overflow-hidden",
        active ? "" : "hidden",
      ].join(" ")}
    >
      <div className="h-full w-1/3 bg-gradient-to-r from-[#f15525] to-[#38bff2] animate-[progress_1.2s_ease-in-out_infinite]" />
      <style>{`
        @keyframes progress {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(50%); }
          100% { transform: translateX(200%); }
        }
      `}</style>
    </div>
  );
}
